module.exports = __webpack_public_path__ + "static/media/heydoor_word_gold_black.a9efefab.png";